import { useHistory } from 'react-router-dom';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { URLPaths } from 'models/enums';
import Button from 'domains/core/components/Button';
import PageLayout from 'domains/core/components/PageLayout';
import brandSetupImage from 'assets/images/png/brand_setup_cropped.png';

const BrandSetupEmptyStatePage = () => {
    const history = useHistory();

    const handleSetUpBrandVoice = () => {
        history.push(URLPaths.SETTINGS_BRAND_EDIT);
    };

    return (
        <Stack data-testid="brand-setup-empty-state-page" role="main" aria-label="Brand Setup - Empty State">
            <PageLayout showSettingsHeader header="brand setup">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems="flex-start"
                    justifyContent="space-between"
                    spacing={4}
                    sx={{ minHeight: 400 }}
                >
                    <Stack maxWidth={480} height={400} spacing={3} justifyContent="flex-end">
                        <Typography variant="h5" fontWeight={600} color="text.primary">
                            set up your brand&apos;s voice and tone
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Register your organization&apos;s tone and messaging standards so AI always generates
                            outreach content that matches your brand.
                        </Typography>
                        <Stack spacing={1}>
                            <Typography variant="subtitle2" fontWeight={600} color="text.primary">
                                AI will use your brand voice to:
                            </Typography>
                            <Stack component="ul" spacing={0.5} sx={{ pl: 0, m: 0, listStyle: 'none' }}>
                                <Stack component="li" direction="row" alignItems="center" spacing={1}>
                                    <CheckCircleOutlineIcon sx={{ fontSize: 20, color: 'green' }} />
                                    <Typography variant="body2" color="text.secondary">
                                        Write consistent outreach content for email and text messages
                                    </Typography>
                                </Stack>
                                <Stack component="li" direction="row" alignItems="center" spacing={1}>
                                    <CheckCircleOutlineIcon sx={{ fontSize: 20, color: 'green' }} />
                                    <Typography variant="body2" color="text.secondary">
                                        Follow your tone and messaging references
                                    </Typography>
                                </Stack>
                                <Stack component="li" direction="row" alignItems="center" spacing={1}>
                                    <CheckCircleOutlineIcon sx={{ fontSize: 20, color: 'green' }} />
                                    <Typography variant="body2" color="text.secondary">
                                        Reduce editing time
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSetUpBrandVoice}
                            data-testid="brand-setup-cta-button"
                            sx={{ width: 200 }}
                        >
                            Set up brand voice
                        </Button>
                    </Stack>
                    <Box
                        sx={{
                            width: 540,
                            height: 540,
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                        }}
                    >
                        <img
                            src={brandSetupImage}
                            alt="Set up your brand voice and tone"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                // transform: 'scale(1.2)',
                            }}
                        />
                    </Box>
                </Stack>
            </PageLayout>
        </Stack>
    );
};

export default BrandSetupEmptyStatePage;
